<template>
  <div class="checkout-generic-error checkout-feedback-screen flow-step">
    <h1>Algo inesperado aconteceu</h1>
    <img src="@/assets/junior-error.png" alt />
    <span>
      Tente finalizar seu cadastro novamente.<br/>Caso o erro persista, entre em contato com nossa
      <a href="https://help.playkids.com" target="_blank">equipe de atendimento!</a>
    </span>
    <btn color="purple" @click="$emit('restartPayment')">Recomeçar</btn>
  </div>
</template>

<script>
export default {
  name: 'checkout-generic-error'
}
</script>
